import { FocusMonitor } from '@angular/cdk/a11y';
import { AfterViewInit, Directive, ElementRef, Host, Optional, Renderer2 } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, FormGroupDirective } from '@angular/forms';
import { Observable, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';

@Directive({
  /* tslint:disable-next-line:directive-selector */
  selector: '[formGroup], [nebulaProgressIndicator]'
})
export class NebulaProgressIndicatorDirective implements AfterViewInit {
  // Focus handling:
  // https://www.w3.org/TR/html5/editing.html#focus-processing-model

  private _actionButtons: Array<HTMLElement>;
  private _spinner: HTMLElement;
  private _spinnerAdded = false;
  private focusedElement: HTMLElement;
  private _disabledControls: Array<AbstractControl> = [];

  constructor(
    @Host() @Optional() private _formGroup: FormGroupDirective,
    private _element: ElementRef,
    private _renderer: Renderer2,
    private monitor: FocusMonitor
  ) {
  }

  public executeAction(action: () => Observable<any> | any) {
    this._actionButtons = [].slice.call((this._element.nativeElement as HTMLElement).querySelectorAll('button[type="submit"]'));
    if ((this._element.nativeElement as HTMLElement).nodeName.toLowerCase() !== 'form') {
      this._formGroup = null;
    }
    if (!this._formGroup) {
      this._actionButtons = [this._element.nativeElement];
    }

    this.focusedElement = (document.activeElement as HTMLElement);
    this.focusedElement.blur();
    if ((this._formGroup && this._formGroup.valid && action)
      || (!this._formGroup && action)) {
      this._toggleSpinner();
      const submit = action();
      if (submit instanceof Observable) {
        submit.pipe(
          take(1),
          catchError((err: Error) => {
            this._toggleSpinner();
            setTimeout(() => {
              this.monitor.focusVia(this.focusedElement, 'keyboard');
            });
            return throwError(err); // para lanzar el error y que aparezca la notificación
          })
        ).subscribe(() => {
          this._toggleSpinner();
        });
      } else {
        this._toggleSpinner();
      }
    }

  }

  private _disableControl(control: AbstractControl) {
    if (control instanceof FormGroup || control instanceof FormArray) {
      const controls = (control instanceof FormGroup) ? Object.values(control.controls) : control.controls;
      controls.forEach(c => this._disableControl(c));
      if (controls.some(c => c.dirty)) {
        control.markAsDirty();
      }
    } else if (control instanceof FormControl && !control.disabled) {
      control.disable({ emitEvent: false });
      this._disabledControls.push(control);
    }
  }

  private _toggleSpinner() {
    if (this._actionButtons.length > 0) {
      const activeButton = this._actionButtons.includes(this.focusedElement) ? this.focusedElement : this._actionButtons[0];
      if (!this._spinnerAdded) {
        if (this._formGroup) {
          this._disableControl(this._formGroup.form);
        }
        this._actionButtons.forEach(e => {
          e.setAttribute('disabled', 'true');
        });
        activeButton.classList.add('hide-label');
        this._renderer.appendChild(activeButton, this._spinner);
        this._spinnerAdded = true;

      } else {
        if (this._formGroup) {
          this._disabledControls.forEach(c => c.enable({ emitEvent: false }));
          this._disabledControls = [];
        }
        this._actionButtons.forEach(e => {
          e.removeAttribute('disabled');
        });
        activeButton.classList.remove('hide-label');
        this._renderer.removeChild(activeButton, this._spinner);
        this._spinnerAdded = false;
      }
    }
  }

  ngAfterViewInit() {
    this._spinner = document.createElement('div');
    this._spinner.classList.add('button-spinner');
  }
}
